<template>
  <a-modal
    :maskClosable="false"
    :width="840"
    :visible="visible"
    :confirmLoading="confirmLoading"
    :cancelText="'取消'"
    :okText="'确定'"
    @cancel="handleCancel"
    :footer="null"
    :zIndex="999"
  >
    <div class="teacher-header">
      <span :class="{ 'item-active': tabIndex == '1' }" @click="tabIndex = 1">老师详情</span>
      <span :class="{ 'item-active': tabIndex == '2' }" @click="tabIndex = 2">审核详情</span>
    </div>
    <!-- 老师详情 -->
    <div v-show="tabIndex == 1">
      <ul class="teacher-info">
        <li>
          <span class="key">头像：</span>
          <span class="value"
            ><a
              target="originalFile"
              :href="teacher.avatarUrl ? teacher.avatarUrl : './teacherIcon.png'"
              ><img
                :src="
                  teacher.avatarUrl
                    ? teacher.avatarUrl +
                      '?x-oss-process=image/resize,m_pad,h_100,w_100,color_F0F0F0'
                    : './teacherIcon.png'
                " /></a
          ></span>
        </li>
        <li>
          <span class="key">审核状态：</span>
          <span class="value">{{ teacher.statusText }}</span>
        </li>
        <li v-if="teacher.status == '2'">
          <span class="key">不通过理由：</span>
          <span class="value">{{ teacher.failReason }}</span>
        </li>
        <li>
          <span class="key">老师名字：</span>
          <span class="value">{{ teacher.nickname }}</span>
        </li>
        <li>
          <span class="key">性别：</span>
          <span class="value">{{ teacher.gender | gender }}</span>
        </li>
        <li>
          <span class="key">手机号：</span>
          <span class="value">{{ teacher.mobile }}</span>
        </li>

        <li>
          <span class="key">执教年限/年：</span>
          <span class="value">{{ teacher.teachingYears }}</span>
        </li>
        <li>
          <span class="key">授课品类：</span>
          <span class="value">{{ teacher.applyCourseType }}</span>
        </li>
        <li>
          <span class="key">银行卡号：</span>
          <span class="value">{{ teacher.bankCardNo }}</span>
        </li>
        <li>
          <span class="key">开户行：</span>
          <span class="value">{{ teacher.bankName }}</span>
        </li>
        <li>
          <span class="key">身份证：</span>
          <span class="value">{{ teacher.cardNo }}</span>
        </li>
        <li v-if="teacher.cardFrontUrl">
          <span class="key">身份证正面照片：</span>
          <span class="value"
            ><a target="originalFile" :href="teacher.cardFrontUrl"
              ><img
                :src="
                  teacher.cardFrontUrl +
                  '?x-oss-process=image/resize,m_pad,h_100,w_100,color_F0F0F0'
                " /></a
          ></span>
        </li>
        <li v-if="teacher.cardBackUrl">
          <span class="key">身份证背面照片：</span>
          <span class="value"
            ><a target="originalFile" :href="teacher.cardBackUrl"
              ><img
                :src="
                  teacher.cardBackUrl + '?x-oss-process=image/resize,m_pad,h_100,w_100,color_F0F0F0'
                " /></a
          ></span>
        </li>
        <!-- --------------- -->

        <li v-if="protraitPhotoUrl">
          <span class="key">2寸免冠照片：</span>
          <span class="value"
            ><a target="originalFile" :href="protraitPhotoUrl"
              ><img
                :src="
                  protraitPhotoUrl + '?x-oss-process=image/resize,m_pad,h_100,w_100,color_F0F0F0'
                " /></a
          ></span>
        </li>

        <li
          style="display: flex; flex-wrap: wrap"
          v-if="teacher.degreeCertificatList && teacher.degreeCertificatList.length"
        >
          <span class="key">学位证与学历证：</span>

          <a-table
            :columns="columns"
            :data-source="degreeCertificatList"
            :pagination="false"
            :bordered="false"
          >
            <div slot="teaTeacherInfoDos" slot-scope="text">
              <a target="originalFile" :href="backUrl(text, 0)"
                ><img :src="backUrl(text, 0)" style="width: 80px"
              /></a>
              <!-- <img :src="backUrl(text, 0)" style="width: 80px" /> -->
            </div>
            <div slot="teaTeacherInfoDos1" slot-scope="text">
              <a target="originalFile" :href="backUrl(text, 1)"
                ><img :src="backUrl(text, 1)" style="width: 80px"
              /></a>
              <!-- <img :src="backUrl(text, 1)" style="width: 80px" /> -->
            </div>
          </a-table>
        </li>
        <li v-if="healthCertificateUrl">
          <span class="key">健康证明：</span>
          <span
            style="padding-right: 6px"
            class="value"
            v-for="(item, index) in healthCertificateUrl"
            :key="index"
            ><a target="originalFile" :href="item"
              ><img :src="item + '?x-oss-process=image/resize,m_pad,h_100,w_100,color_F0F0F0'" /></a
          ></span>
        </li>
        <li v-if="noCriminalUrl">
          <span class="key">无犯罪证明：</span>
          <span class="value"
            ><a target="originalFile" :href="noCriminalUrl"
              ><img
                :src="
                  noCriminalUrl + '?x-oss-process=image/resize,m_pad,h_100,w_100,color_F0F0F0'
                " /></a
          ></span>
        </li>
        <li v-if="noCrimeExpiryDate">
          <span class="key">无犯罪证明有效期：</span>
          <span class="value">{{noCrimeExpiryDate}}</span>
        </li>
        <li v-if="talkingVideoUrl">
          <span class="key">说课视频：</span>
          <span class="value">
            <a-button type="primary" @click="showModal"> 查看 </a-button>
            <a-modal title="说课视频" :visible="isVideo" :footer="null" @cancel="videoCancel">
              <video
                class="videoSize"
                controls="controls"
                ref="videoPlay"
                :src="talkingVideoUrl"
              ></video>
            </a-modal>
          </span>
        </li>
        <!-- --------------- -->
        <li v-if="credentialInfoUrl">
          <span class="key">老师资质证书：</span>
          <span style="padding-right: 6px" class="value" v-for="(item, index) in credentialInfoUrl" :key="index"
            ><a target="originalFile" :href="item"
              ><img :src="item + '?x-oss-process=image/resize,m_pad,h_100,w_100,color_F0F0F0'" /></a
          ></span>
        </li>
        <li v-if="teacher.experience">
          <span class="key">校内教师本校任教证明或<br />校外教师从业经验证明：</span>
          <span style="padding-right: 6px" class="value" v-for="(item, index) in teacher.experience" :key="index"
            ><a target="experience" :href="item.fileUrl"
              ><img :src="item.fileUrl + '?x-oss-process=image/resize,m_pad,h_100,w_100,color_F0F0F0'" /></a
          ></span>
        </li>
        <li v-if="teacher.intro">
          <span class="key">老师介绍：</span>
          <pre class="value intro">{{ teacher.intro }}</pre>
        </li>
      </ul>
    </div>

    <!-- 审核详情 -->
    <div class="rela-box" v-show="tabIndex == 2">
      <div class="in-item">
        <div class="key">
          审核状态
          <span
            class="value ml30"
            :class="{
              'value-rejected': status == '2',
              'value-resolve': status == '1',
              'value-examine': status == '0' || status == '4' || status == '5' || status == '3',
            }"
            >{{
              status == '0'
                ? '待审核'
                : status == '1'
                ? '审核通过'
                : status == '2'
                ? '审核不通过'
                : status == '3'
                ? '待提交'
                : status == '4'
                ? '初审通过'
                : '复审通过'
            }}</span
          >
        </div>
        <div class="value">
          <ul class="process">
            <li class="process-item" v-for="item in checkOperateLogArr" :key="item.id">
              <span class="operate">{{ item.operateLog }}</span>
              <span
                :class="[item.stateAfter == 1 ? 'exa1' : item.stateAfter == 2 ? 'exa2' : 'exa3']"
              >
                {{ item.stateAfterText }}
              </span>
              <div class="comment" v-if="item.userComment">审核意见：{{ item.userComment }}</div>
              <div class="download-btn" v-if="item.attachmentUrl">
                <span>相关附件：{{ item.fileName }}</span>
                <a
                  :href="rootUrl + item.attachmentUrl"
                  :download="rootUrl + item.attachmentUrl"
                  target="_blank"
                >
                  下载</a
                >
              </div>
            </li>
          </ul>
        </div>
        <!-- 退回修改按钮 -->
      </div>
      <div class="back-modify" v-if="status == 2" @click="backModify()">退回修改</div>
    </div>
  </a-modal>
</template>

<script>
import teacher from '../../api/teacher'
const columns = [
  {
    title: '学历',
    dataIndex: 'description',
  },
  {
    title: '毕业院校',
    dataIndex: 'text',
  },
  {
    title: '学历证',
    dataIndex: 'teaTeacherInfoDos',
    scopedSlots: { customRender: 'teaTeacherInfoDos' },
  },

  {
    title: '学位证',
    dataIndex: 'teaTeacherInfoDos1',
    scopedSlots: { customRender: 'teaTeacherInfoDos1' },
  },
]

export default {
  name: 'teacherDetailModal',
  data() {
    return {
      columns,
      visible: false,
      confirmLoading: false,
      teacher: {
        degreeCertificatList: [],
      },
      checkOperateLogArr: [], // 审核记录
      rootUrl: '', // 基地址
      degreeCertificatUrl: '', // 学历证url
      noCriminalUrl: '', // 无犯罪证明url
      noCrimeExpiryDate:'', // 无犯罪证明有效期
      protraitPhotoUrl: '', // 免冠照片url
      talkingVideoUrl: '', // 说课视频url
      healthCertificateUrl: [], // 健康证明url
      degreeCertificatArr: [], // 学位证学历证
      credentialInfoUrl: [], //教师资质
      status: '', // 审核状态
      tabIndex: 1, // tab切换
      userInfo: null,
      isVideo: false,
      degreeCertificatList: [],
    }
  },
  methods: {
    //初始化，显示
    init(detail) {
      this.visible = true
      this.teacher = detail
      this.getHostUrl()
      this.getCheckOperateLog(detail.id)
      if (this.teacher.degreeCertificatList) {
        this.degreeCertificatList = detail.degreeCertificatList.map(item => {
          return {
            teaTeacherInfoDos1: item.teaTeacherInfoDos,
            ...item,
          }
        })
        console.log(this.degreeCertificatList)
        console.log(this.teacher.healthCertificateUrl)
        // this.degreeCertificatUrl = this.teacher.degreeCertificatList[0].fileUrl
        // this.teacher.degreeCertificatList.forEach(v => {
        //   if (v.teaTeacherInfoDos.length > 0) {
        //     v.teaTeacherInfoDos.forEach(m => {
        //       if (m.fileUrl) {
        //         this.degreeCertificatArr.unshift(m.fileUrl)
        //       }
        //     })
        //   }
        // })
      }
      if (this.teacher.noCriminalUrl) {
        this.noCriminalUrl = this.teacher.noCriminalUrl[0].fileUrl
      }
      if (this.teacher.noCrimeExpiryDate) {
        this.noCrimeExpiryDate = this.teacher.noCrimeExpiryDate[0].text
      }
      if (this.teacher.protraitPhotoUrl) {
        this.protraitPhotoUrl = this.teacher.protraitPhotoUrl[0].fileUrl
      }
      if (this.teacher.talkingVideoUrl) {
        this.talkingVideoUrl = this.teacher.talkingVideoUrl[0].fileUrl
      }
      if (this.teacher.healthCertificateUrl) {
        this.healthCertificateUrl = this.teacher.healthCertificateUrl.map(item => {
          return item.fileUrl
        })
      }
      if (this.teacher.credentialInfoUrl) {
        this.credentialInfoUrl = this.teacher.credentialInfoUrl.map(item => {
          return item.fileUrl
        })
      }
      console.log('老师详情---', this.teacher)
    },
    backUrl(list, type) {
      if (!list.length) return ''
      const filterList = list.filter(item => item.extType === type)
      if (!filterList.length) return ''
      return filterList[0].fileUrl
    },
    //隐藏
    handleCancel() {
      this.visible = false
      this.degreeCertificatUrl = ''
      this.noCriminalUrl = ''
      this.protraitPhotoUrl = ''
      this.talkingVideoUrl = ''
      this.healthCertificateUrl = ''
      this.degreeCertificatArr = []
      this.credentialInfoUrl = []
      this.$emit('closeForm')
    },

    // 获取审核详情
    getCheckOperateLog(id) {
      teacher.getCheckOperateLog(id).then(res => {
        console.log('获取审核详情-----', res)
        res.data.checkOperateLogDos.forEach(v => {
          if (v.attachmentUrl) {
            let fileArr = v.attachmentUrl.split('_')
            // v.attachmentUrl = encodeURIComponent(v.attachmentUrl)
            if (fileArr[1] != undefined) {
              v.attachmentUrl = `${encodeURIComponent(fileArr[0])}_${fileArr[1]}`
            } else {
              v.attachmentUrl = encodeURIComponent(v.attachmentUrl)
            }

            v.fileName = fileArr[1]
            if (v.fileName == undefined) {
              v.fileName = '无附件名'
            }
          }
        })
        this.status = res.data.status
        this.checkOperateLogArr = res.data.checkOperateLogDos
      })
    },

    // 查看视频
    showModal() {
      this.isVideo = true
    },

    // 关闭视频
    videoCancel() {
      this.isVideo = false
      this.$refs.videoPlay.pause()
    },

    getHostUrl() {
      const locationHost = location.host
      this.rootUrl = globalConfig.rootUrl + '/api/pcWeb/aliyun/getFile?url='
      console.log('rootUrl', this.rootUrl)
    },
    // 退回修改
    backModify() {
      this.$emit('back-modify', this.teacher)
    },
  },
  created() {
    this.$store.dispatch('getUserInfo').then(res => {
      this.userInfo = res
    })
  },
}
</script>
<style lang="scss" scoped>
@import 'src/config/var';
.ml30 {
  margin-left: 30px;
}
.teacher-header {
  height: 39px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.09);
  margin-bottom: 24px;
  span {
    height: 100%;
    display: inline-block;
    font-size: 16px;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.85);
    margin-right: 36px;
    cursor: pointer;
  }
  .item-active {
    color: #3198ff;
    border-bottom: 2px solid #3198ff;
  }
}
.teacher-info {
  text-align: left;
  height: calc(100vh - 280px);
  overflow-y: auto;
  overflow-x: hidden;
  li {
    font-size: 16px;
    line-height: 40px;
    padding: 6px 0px;
    .key {
      display: inline-block;
      font-weight: 600px;
      color: $normal-color-light;
      width: 180px;
      text-align: right;
    }
    .value {
      vertical-align: top;
      color: $normal-color-dark;
      padding-left: 6px;
      display: inline-block;
      padding-right: 16px;
      text-align: left;
      .item {
        border-bottom: 1px solid $border-color;
      }
      img {
        width: 100px;
        height: 100px;
        vertical-align: top;
      }
    }
    .list {
      margin-left: 100px;
    }
    .oper {
      color: $primary-color-dark;
      cursor: pointer;
    }
    .intro {
      width: 100%;
      padding: 0px 20px 0px 50px;
      display: inline-block;
      color: $normal-color-dark;
    }
  }
  .update-oper {
    text-align: center;
  }
}

.in-item {
  height: calc(100vh - 280px);
  overflow-y: auto;
  overflow-x: hidden;
  margin-top: 20px;
  padding-bottom: 10px;
  > .key {
    color: rgba(0, 0, 0, 0.85);
    font-size: 20px;
    font-weight: 600;
  }
  > .value {
    font-size: 14px;
    color: #606266;
    margin-top: 19px;
    margin-left: 74px;
  }

  .process {
    width: 100%;
    height: 100%;
    overflow: auto;
    margin-left: 52px;
    margin-top: 19px;
    &-item {
      margin-bottom: 10px;

      .operate {
        color: #c0c4cc;
        margin-left: 26px;
      }
      // 审核意见
      .comment {
        color: #333;
        margin-left: 30px;
      }
      // 下载附件
      .download-btn {
        color: #333;
        margin-left: 30px;
        a {
          margin-left: 20px;
        }
      }
    }
    li:before {
      content: '';
      width: 4px;
      height: 4px;
      display: inline-block;
      border-radius: 50%;
      background: #bdbdbd;
      vertical-align: middle;
    }
  }

  // 审核通过颜色
  .exa1 {
    color: #19ca3c;
  }
  // 审核驳回颜色
  .exa2 {
    color: #f95050;
  }
  // 初审、复审颜色
  .exa3 {
    color: #ffa91f;
  }
}
// 相对父盒子定位
.rela-box {
  position: relative;
  // 退回修改按钮
  .back-modify {
    width: 108px;
    height: 32px;
    font-size: 14px;
    color: #fff;
    border-radius: 4px;
    line-height: 32px;
    text-align: center;
    background: #3198ff;
    position: absolute;
    bottom: 0;
    right: 18px;
    cursor: pointer;
  }
}

// 说课视频大小
.videoSize {
  width: 100%;
  height: 350px;
}

.teacher-check {
  margin-top: 16px;
  text-align: center;
}

.check-confirm {
  margin-top: 16px;
  textarea {
    width: 300px;
    margin-left: 376px;
    vertical-align: middle;
    margin-right: 8px;
  }
}

.value-resolve {
  color: #37c847 !important;
}
.value-rejected {
  color: #f54d15 !important;
}
.value-examine {
  color: #ffa91f !important;
}
a.open-file {
  text-decoration: none;
}
</style>
